<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt1">
<h1 class="part"><a id="page17"></a><span class="big1">Part I</span><br/><br/>The Founders</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172958_epub_pt1_r1.vue?7198699f